import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import ROUTES from 'config/routes';
import Button from 'components/Button';
import ForumModule from 'modules/forum';


class CardMenu extends Component {

  handleClickOutside = (event) => {
    const { onClose } = this.props;
    if (onClose) {
      onClose(event);
    }
  }
  handleFreePromote = (event) => {
    const { payForumPost, id } = this.props;
    payForumPost({ id: id });
  }

  render() {
    const { id, isNeedPay, freePosts } = this.props;

    return (
      <div className="card-item__menu-container">
        <ul className="card-menu">
          <li className="card-menu__item">
            <Button
              className="card-menu__link"
              to={`${ROUTES.editForum}/${id}`} >Edit</Button>
          </li>
          {
            isNeedPay
              ? freePosts > 0
                ? <li className="card-menu__item">
                  <Button
                    className="card-menu__link"
                    onClick={this.handleFreePromote}>promote for free</Button>
                </li>
                : <li className="card-menu__item">
                  <Button
                    className="card-menu__link"
                    to={`${ROUTES.paymentForum}/${id}`}>Pay and post</Button>
                </li>
              : null
          }
        </ul>
      </div>
    );
  }
}

CardMenu.propTypes = {
  id: PropTypes.number,
};

CardMenu.defaultProps = {
};

export default compose(
  connect(
    null,
    {
      payForumPost: ForumModule.payForumPost,
    }
  ),
  onClickOutside
)(CardMenu);